import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { box, container, loadingButton, pageTitle } from '@/ui/components';
import { useTask } from '@/ui/concerns';
import { create } from '@/services/api/resources/entityType';
import { toastAndRedirect } from '@/ui/helpers/uiHelper';
import { hasFeature, hasPermission, Permissions } from '@/ui/auth/auth';
import { useEntityTypeForm } from './useEntityTypeForm';
import { useEntityTypeRecord } from './useEntityTypeRecord';
import { renderForbiddenPage } from '../error/ForbiddenPage';
import { renderResourceTeaserPage } from '@/ui/pages/teasers/ResourceTeaserPage';
import { queryTabName, EntityItemsTabNames } from '@/ui/components/navigation/constants';

export const EntityTypeCreatePage = defineComponent({
  name: 'EntityTypeCreatePage',
  setup() {
    if (!hasFeature('entityTypes')) {
      return renderResourceTeaserPage(t('common.entity-types'));
    }

    if (!hasPermission(Permissions.MANAGE_ENTITY_TYPES)) {
      return renderForbiddenPage;
    }

    const record = useEntityTypeRecord();

    const sendRecord = useTask(
      () => create(record.value),
      () => {
        toastAndRedirect(t('entity-type.created'), 'entityItems', { [queryTabName]: EntityItemsTabNames.TYPES });
      },
    );

    const { formFields, handleSubmit } = useEntityTypeForm(record, sendRecord);

    return function render() {
      return container(
        [
          pageTitle(t('entity-type.create')),
          box([
            h('form', [
              ...formFields(),
              loadingButton(
                t('entity-type.create'),
                handleSubmit,
                sendRecord.state.value.pending,
              ),
            ]),
          ]),
        ],
        'narrow',
      );
    };
  },
});
